import { Configuration } from '@toki-power/public-api';

import { useAuthUser } from '~/auth';

import { buildApiConfig } from '../buildApiConfig';

type ApiConfigReturn = () => Promise<Configuration>;

export const useApiConfig = (): ApiConfigReturn => {
  const { getToken } = useAuthUser();

  return async () => {
    const token = await getToken();

    return buildApiConfig(token);
  };
};
